import { isEditing, calcAge } from "../common/common"
import { captureException } from "../common/error"
import { setterAction } from "../common/redux"
import tracker from "../common/tracker"
import * as t from "./actionTypes"
import * as interviewActions from "../interview/actions"
import * as integrationActions from "../integration/actions"
import * as simpleFlowActions from "../simpleFlow/actions"
import * as generator from "../chatItemGenerator"
import Source from "../interview/Source"
import { takeSnapshot } from "../redux/actions"
import { setTermModalShown, setShowGinaModal } from "../interview/actions"
import { _setProfiles } from "../account/actions"
import { messages } from "./../chatItemGenerator"
import { SubDomain, QueryStringBrand } from "../common/common"
import { IS_PRODUCTION } from "../common/constants"

export const setPov = setterAction(t.SET_POV)
export const setSex = setterAction(t.SET_SEX)
export const _setAge = setterAction(t.SET_AGE)
export const setAgeInputAttempted = setterAction(t.SET_AGE_INPUT_ATTEMPTED)
export const setName = setterAction(t.SET_NAME)
export const setProfileID = setterAction(t.SET_PROFILE_ID)
export const setAgeError = setterAction(t.SET_AGE_ERROR)
export const setInfantExplanation = setterAction(t.SET_INFANT_EXPLANATION)

const invalidPediatricAgeCopy = [
  "Alright. We definitely want to help you figure this out, but we at Buoy Health believe that if you are worried about a baby or young child, then it’s time to call the doctor!",
  "Even when you take the very best care of a little one, things aren't always perfect.  Since infants and younger children can become sick more quickly than older ones, they require a little more caution.",
  "If you can’t talk to a doctor right now, or if you think they need immediate medical care, then you should bring them to a hospital emergency room.",
  "Please call 911 if you cannot safely transport them to the hospital.",
]

// nextQuestion is envoked by questionAfterTerms
// nextQuestion is registered in displayTermsWall
let nextQuestion = () => () => console.error("No registered questionAfterTerms")

export const displayTermsWall = (
  registerNextQuestion = nextQuestion,
  ...args
) => (dispatch, getState) => {
  let { brand } = getState()
  const SUBDOMAIN_NAMES = [
    "froedtert",
    "fhstaff",
    "bannerhealth",
    "houstonmethodist",
    "rcw",
    "nyt",
    "bch",
  ]

  if (brand.termsAgreed) return false

  // registerNextQuestion for EULA/GINA modal to call on accept terms
  nextQuestion = registerNextQuestion.bind(this, ...args)

  // show EULA to all subdomain clients
  if (IS_PRODUCTION) {
    if (SubDomain) return dispatch(setTermModalShown(true))
  } else {
    // query strings trump subdomains for testing purposes outside of prod
    // theres no way to differentiate subdomain clients on local
    if (SUBDOMAIN_NAMES.includes(QueryStringBrand))
      return dispatch(setTermModalShown(true))
  }

  // show GINA to all others
  tracker.showGinaModal()
  return dispatch(setShowGinaModal(true))
}

export const questionAfterTerms = () => (dispatch, getState) => {
  // This is a called by the EULA and GINA modals to continue the interview
  dispatch(nextQuestion())
}

export const identityResponse = response => (dispatch, getState) => {
  let { chatList, integration } = getState()

  if (isEditing(chatList.items, chatList.active)) {
    dispatch(interviewActions.deleteChatItems())
  }
  dispatch(interviewActions.setResponse([response]))
  dispatch(setPov(response.pov))

  // Set sex and age if using a previously saved profile
  if (response.age || response.age === 0) {
    dispatch(_setAge({ value: response.age, unit: "years" }))
  }
  if (response.sex) {
    dispatch(setSex(response.sex))
  }
  if (response.id) {
    dispatch(setProfileID(response.id))
    if (!integration.marketplaceToken) {
      dispatch(integrationActions.getUserEmployer(response.id))
    }
  }

  tracker.pov()
  dispatch(interviewActions.addChatItem(generator.response(response.text)))

  // display terms and conditions or proceed to next question
  if (!dispatch(displayTermsWall(sexQuestion, response))) {
    dispatch(interviewActions.setLoading(true, "identifiers/identityResponse"))
    dispatch(sexQuestion(response))
  }
}

export const sexQuestion = response => (dispatch, getState) => {
  let { chatList } = getState()

  dispatch(interviewActions.setLoading(false))

  if (!response) {
    let activeItem = chatList.items[chatList.active - 1]
    if (activeItem.response.length > 0) {
      response = activeItem.response[0]
    }
  }

  if (response.token === "self" || response.token === "other") {
    dispatch(interviewActions.addChatItem(generator.sexQues(response.token)))
  } else {
    dispatch(setName(response.token))
    dispatch(setSex(response.sex))
    dispatch(newVisit(response.token))
    tracker.sex()
    tracker.age()
    tracker.profile()
  }
}

export const sexResponse = response => (dispatch, getState) => {
  let { chatList, identifiers } = getState()

  if (isEditing(chatList.items, chatList.active)) {
    dispatch(interviewActions.deleteChatItems())
  }

  dispatch(interviewActions.setResponse([response]))
  dispatch(setSex(response.token))
  tracker.sex()
  dispatch(_setAge({ month: "", day: "", year: "" }))
  dispatch(interviewActions.addChatItem(generator.response(response.text)))

  dispatch(
    interviewActions.addChatItem(
      generator.ageQues(identifiers.pov, response.token)
    )
  )
}

export const ageSubmit = () => (dispatch, getState) => {
  let { chatList, identifiers, auth, loading } = getState()

  if (loading) return

  let { pov, age, sex } = identifiers

  if (isEditing(chatList.items, chatList.active)) {
    dispatch(interviewActions.deleteChatItems())
  }

  dispatch(interviewActions.setResponse([age]))

  let response = generator.response([
    messages.identifiersAgeResponse,
    { age: age.value },
  ])

  dispatch(setName(""))
  dispatch(interviewActions.addChatItem(response))
  tracker.age()

  let yrsOld = calcAge(age)

  if (yrsOld >= 2) {
    if (auth.isAnonymous) {
      dispatch(nameSubmit(false))
    } else {
      dispatch(interviewActions.addChatItem(generator.nameQues(pov, sex)))
    }
  } else {
    dispatch(interviewActions.setLoading(false))

    const items = invalidPediatricAgeCopy.map(s => generator.systemMessage(s))
    dispatch(interviewActions.addChatItems(items))
  }
}

export const setAge = age => (dispatch, getState) => {
  let { ageInputAttempted } = getState().identifiers

  if (!ageInputAttempted) {
    dispatch(setAgeInputAttempted(true))
  }

  dispatch(_setAge({ ...age }))
}

export const initVisit = (name = "", profileId = "") => (
  dispatch,
  getState
) => {
  let { brand, integration } = getState()
  let referrer = document.referrer

  let marketplaceToken =
    integration && integration.configuredExperience
      ? integration.marketplaceToken
      : undefined

  // Default the variant to A
  let variant = "A"

  if (window.variant !== undefined) {
    variant = window.variant
  }
  return Source.newVisit(
    name,
    referrer,
    variant,
    marketplaceToken || brand.token,
    profileId
  )
}

export const newVisit = name => (dispatch, getState) => {
  let { editor, identifiers, simpleFlow } = getState()
  let { pov, sex, name, profile_id } = identifiers
  const { diagnosis: simpleFlowDiagnosis } = simpleFlow

  dispatch(interviewActions.setLoading(true, "identifiers/newVisit"))
  return dispatch(initVisit(name, profile_id))
    .then(data => {
      dispatch(interviewActions.setVisitToken(data.token))
      dispatch(integrationActions.setZipcode(data.zip_code))
      if (data.zip_code)
        dispatch(integrationActions.setDidCaptureLocation(true))
      if (process.env.ENVIRONMENT !== "research") {
        Source.startVisitTracker().catch(captureException)
      }
      dispatch(interviewActions.setLoading(false))

      let standardInterviewItems = [
        generator.systemMessage(messages.interviewMessagesBeginning),
        generator.searchQuestion(true, pov, sex),
        generator.symptomBubble(true),
      ]

      if (simpleFlowDiagnosis !== "") {
        // wait for newVisitActions to complete before submitting filters
        dispatch(simpleFlowActions.newVisitActions()).then(() => {
          // Simple coronavirus flow interview split point
          if (simpleFlow.cardinalResponses.length > 0) {
            // cardinal symptoms presented flow
            dispatch(simpleFlowActions.submitPresentations())
          } else {
            // cardinal symptoms NOTA flow
            dispatch(interviewActions.addChatItems(standardInterviewItems))
          }
        })
      } else {
        // normal interview flow
        dispatch(interviewActions.addChatItems(standardInterviewItems))
      }

      takeSnapshot("search")

      if (editor && editor.isActive && editor.activeCase) {
        Source.attachCase(editor.activeCase.id)
      }
    })
    .catch(error => dispatch(interviewActions.genericError(error)))
}

export const finishIdentifiers = () => (dispatch, getState) => {
  const { identifiers } = getState()
  const { pov, sex, age, name = "" } = identifiers

  dispatch(interviewActions.setLoading(true, "identifiers/finishIdentifiers"))
  const yrsOld = calcAge(age)

  return Source.submitIdentifiers(name, yrsOld, sex, pov === "self")
    .then(res => {
      dispatch(setProfileID(res.id))
      dispatch(newVisit(name))
      dispatch(_setProfiles([res]))
    })
    .catch(error => {
      if (error.msg === "Illegal character") {
        dispatch(
          interviewActions.addChatItem(
            generator.error(
              "Sorry, there is a " +
                "character we don't know how to handle in that name. Please try again"
            )
          )
        )
      } else {
        dispatch(interviewActions.genericError(error))
      }
    })
}

export const nameSubmit = (userGenerated = true) => (dispatch, getState) => {
  let { chatList, identifiers, loading } = getState()
  let { name } = identifiers

  if (loading) return
  let response = name || "Skip"
  tracker.name()
  if (isEditing(chatList.items, chatList.active)) {
    dispatch(interviewActions.deleteChatItems())
  }
  if (userGenerated) {
    dispatch(interviewActions.setResponse(response))
    dispatch(interviewActions.addChatItem(generator.response(response)))
  }
  dispatch(finishIdentifiers())
}



// WEBPACK FOOTER //
// ./assets/identifiers/actions.js